import { useEffect, useState, useRef } from 'react'
import { HubConnectionBuilder } from '@microsoft/signalr';


const RefreshNotifications = ({setRefresh2}) => {

    const [ connection, setConnection ] = useState(null);
    
    useEffect(()=>{

        const sHubURL = process.env.REACT_APP_API_BASE_URL + 'notify';

        const newConnection = new HubConnectionBuilder()
        .withUrl( sHubURL)
        .withAutomaticReconnect()
        .build();

        setConnection(newConnection);

    },[]);


    useEffect(()=>{

        if(connection){
            connection.start()
            .then(result => {
    
                const sNotificationMethodName = "ReceiveUpdate";    
   
                connection.on(sNotificationMethodName, message =>{

                    if(message==="change")
                        {
                        setRefresh2();
                        // setRefresh1(prevRefreshData => prevRefreshData +1);
                       // setRefresh1();
                        }
                    
                }
                
                )
            })
            .catch(e=> console.log("connection failed : ",e ) )
        }

    },[connection]);


}

export default RefreshNotifications